import React, { useState, useEffect } from "react";
import { FaRegPlusSquare } from "react-icons/fa";
import Header from "../../header";
import Navvbar from "../../Navvbar";
import Sidebar from "../../../Sidebar";
import "./ScanningAssigning.css";

// Departments yahan se change/add kar sakti hain (expand = icon dikhana hai ya nahi)
const DEPARTMENTS = [
  { id: "all", name: "All Departments", isAll: true },
  { id: "crown", name: "CROWN AND BRIDGE", expand: true },
  { id: "ortho", name: "ORTHODONTIC" },
  { id: "implants", name: "IMPLANTS" },
  { id: "alldept", name: "All Departments", expand: true },
  { id: "none", name: "No Department", expand: true },
];

const ScanningAssigning = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // key: `${deptId}|${userId}|scan` ya `|assign`  (default = checked)
  const [unchecked, setUnchecked] = useState({});

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch("https://hms.backend.hiragroupcloud.com/api/auth/labusers", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        if (!res.ok) throw new Error(`Error: ${res.status}`);
        const data = await res.json();
        setUsers(
          Array.isArray(data.users)
            ? data.users.map((u) => ({
                id: u.userId || u._id,
                name: `${u.firstName || u.first_name || ""} ${
                  u.lastName || u.last_name || ""
                }`.trim(),
              }))
            : []
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const rows = DEPARTMENTS.filter((d) => !d.isAll);
  const key = (d, u, t) => `${d}|${u}|${t}`;
  const isChecked = (d, u, t) => !unchecked[key(d, u, t)];

  const toggle = (d, u, t) =>
    setUnchecked((prev) => {
      const next = { ...prev };
      const k = key(d, u, t);
      if (next[k]) delete next[k];
      else next[k] = true;
      return next;
    });

  // "All Departments" (top row) poore column ko on/off karta hai
  const allChecked = (u, t) => rows.every((r) => isChecked(r.id, u, t));
  const toggleAll = (u, t) =>
    setUnchecked((prev) => {
      const next = { ...prev };
      const makeChecked = !allChecked(u, t);
      rows.forEach((r) => {
        const k = key(r.id, u, t);
        if (makeChecked) delete next[k];
        else next[k] = true;
      });
      return next;
    });

  const renderCell = (checked, onChange, label, userId, idx) => (
    <td key={label + userId} className={idx % 2 === 0 ? "scan-alt" : ""}>
      <label className="scan-check">
        <input type="checkbox" checked={checked} onChange={onChange} />
        {label}
      </label>
    </td>
  );

  return (
    <>
      <Header />
      <Navvbar />
      <br />

      <div className="scan-wrapper">
        <div className="scan-row">
          <div className="scan-sidebar-col">
            <Sidebar />
          </div>

          <div className="scan-main-col">
            <h1 className="scan-heading">Scanning and Assigning</h1>

            {loading && <p>Loading users...</p>}
            {error && !loading && (
              <div className="alert alert-danger">Error: {error}</div>
            )}

            {!loading && !error && (
              <div className="scan-table-wrap">
                <table className="scan-table">
                  <thead>
                    <tr className="scan-head-top">
                      <th className="scan-dept-col">Departments</th>
                      <th colSpan={users.length * 2}>Users</th>
                    </tr>
                    <tr className="scan-head-users">
                      <th className="scan-dept-col"></th>
                      {users.map((u, i) => (
                        <th
                          key={u.id}
                          colSpan={2}
                          className={i % 2 === 0 ? "scan-alt" : ""}
                        >
                          {u.name}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {DEPARTMENTS.map((d) => (
                      <tr key={d.id}>
                        <td className="scan-dept-col">
                          {d.expand && <FaRegPlusSquare className="scan-exp" />}
                          {d.name}
                        </td>

                        {users.map((u, i) => [
                          renderCell(
                            d.isAll ? allChecked(u.id, "scan") : isChecked(d.id, u.id, "scan"),
                            () => (d.isAll ? toggleAll(u.id, "scan") : toggle(d.id, u.id, "scan")),
                            "Scan",
                            u.id + "s" + d.id,
                            i
                          ),
                          renderCell(
                            d.isAll ? allChecked(u.id, "assign") : isChecked(d.id, u.id, "assign"),
                            () => (d.isAll ? toggleAll(u.id, "assign") : toggle(d.id, u.id, "assign")),
                            "Be Assigned",
                            u.id + "a" + d.id,
                            i
                          ),
                        ])}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScanningAssigning;